import { ClientFactory, ClientHelper, IEhicAanvragenEndpointClient } from "@klantondersteuning-btl/client";
import { ResponseMapper } from "@klantondersteuning-btl/shared";
import { SchemaToRequestMapper } from "../mapper/SchemaToRequestMapper";
import { EhicFormulierSchemaModel } from "../schema/EhicFormulier";

export class KlantOndersteuningService {
  private readonly client: IEhicAanvragenEndpointClient;
  private readonly schemaToRequestMapper: SchemaToRequestMapper;
  private readonly responseMapper: ResponseMapper;

  constructor(apiUrl: string) {
    const clientFactory = new ClientFactory(apiUrl);
    this.client = clientFactory.getEhicAanvragenClient();
    this.schemaToRequestMapper = new SchemaToRequestMapper();
    this.responseMapper = new ResponseMapper();
  }

  ehicFormulier = (ehicFormulier: EhicFormulierSchemaModel): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      try {
        const result = this.schemaToRequestMapper.map(ehicFormulier);
        
        this.client
          .ehicAanvragen(result)
          .then((response) => {
            resolve(this.responseMapper.map(response));
          })
          .catch((reason: any) => {
            reject(ClientHelper.getErrorMessage(reason));
          });
      } catch {
        reject();
      }
    });
  };
}
